import React from 'react';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

function MobileSection() {
  const section = setup.mobileCapabilities;
  if (!section) return null;

  return (
    <MotionSection id="mobile">
      <SectionHeader eyebrow="Hardware" title={section.title} subtitle={section.subtitle} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {section.items.map((item) => (
          <div key={item.name} className="ui-card p-5">
            <div className="w-9 h-9 rounded-lg border border-line bg-canvas-muted flex items-center justify-center text-ink-secondary mb-3">
              <PhoneAndroidOutlinedIcon sx={{ fontSize: 18 }} />
            </div>
            <h3 className="text-sm font-semibold text-ink mb-1.5">{item.name}</h3>
            <p className="text-sm text-ink-muted leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </MotionSection>
  );
}

export default MobileSection;
